import logo from './logo.svg';
import './App.css';
import UpdateQueryForm from './UpdateQueryForm.jsx';
function App() {
  return (
    <div className="App">
      <UpdateQueryForm/>
    </div>
  );
}

export default App;
